import { Button, styled } from '@mui/material';

export const ErrorButton = styled(Button)`
  flex: 1;
  height: 28px;
  border-radius: 8px;
  box-shadow: none;
  background-color: var(--background-badge-red-accent, #e6483d) !important;
  text-transform: none;
`;
